<template>
  <div id="carrier-details">
    <div class="form-group col-md-12">
      <label v-if="isDomestic" for="" class="control-label">Shipping Domestic Carrier & Service Level:</label>
      <label v-if="isInternational" for="" class="control-label">Shipping International Carrier & Service Level:</label>
    </div>
    <div class="form-group col-md-12" v-if="isInternational">
      <label class="control-label required"> Do you need direct transportation to the international address? </label>
      <div class="ship-radio-btns">
        <label class="radio-inline">
          <input
            :id="'transportInternationallyYes' + index"
            v-model="address.carrierDetails.transportInternationally"
            type="radio"
            value="Yes"
            @blur="$v.carrierDetails.transportInternationally.$touch"
            @change="transportInternationallyChanged"
          />
          <span>Yes</span>
        </label>
        <label class="radio-inline">
          <input
            :id="'transportInternationallyNo' + index"
            v-model="address.carrierDetails.transportInternationally"
            type="radio"
            value="No"
            @blur="$v.carrierDetails.transportInternationally.$touch"
            @change="transportInternationallyChanged"
          />
          <span>No</span>
        </label>
      </div>
      <div
        v-if="!$v.carrierDetails.transportInternationally.required && $v.carrierDetails.transportInternationally.$error"
        class="text-danger"
      >
        Please select do you need direct transportation to the international address
      </div>
    </div>
    <div class="form-group col-md-12 row" v-if="isInternational && address.carrierDetails.transportInternationally == 'Yes'">
      <div class="col-md-12">
        <label class="control-label required" :for="'oneFiftyIntShipment-' + index"
          >International Carrier & Service Level for shipments 1-150 lbs:
          <tooltip
            :id="'onefifty-int-shipment' + index"
            content="These carriers pick up on a daily business-day basis from GE, providing instant tracking/AWB numbers & AES reporting requirements and deliver to your International customer location."
            class="product-helpinfo"
            effect="scale"
            placement="right"
            ><i class="fa fa-question-circle"></i>
          </tooltip>
        </label>
      </div>
      <div class="col-md-3">
        <select
          :id="'oneFiftyIntShipment-' + index"
          v-model="address.carrierDetails.oneFiftyIntShipment"
          :name="'oneFiftyIntShipment-' + index"
          class="form-control"
          @blur="$v.carrierDetails.oneFiftyIntShipment.$touch()"
        >
          <option :value="{ id: '', name: '' }">Select Carrier & Service Level</option>
          <option
            v-for="list in oneFiftyIntCarrierList"
            :key="list.carrierId"
            :value="{ id: list.carrierId, name: list.carrierServiceNm }"
          >
            {{ list.carrierServiceNm }}
          </option>
        </select>
      </div>
      <div
        class="text-danger col-md-12"
        v-if="!$v.carrierDetails.oneFiftyIntShipment.required && $v.carrierDetails.oneFiftyIntShipment.$error"
      >
        Please select International Carrier & Service Level for shipments 1-150 lbs
      </div>
    </div>
    <div
      class="form-group col-md-12 row"
      v-if="isDomestic || (isInternational && address.carrierDetails.transportInternationally == 'No')"
    >
      <div class="col-md-12">
        <label class="control-label required" :for="'oneFiftyDomShipment-' + index"
          >Domestic Carrier & Service Level for shipments 1-150 lbs:
          <tooltip
            :id="'onefifty-dom-shipment' + index"
            :content="shipmentTooltipMsg"
            class="product-helpinfo"
            effect="scale"
            placement="right"
            ><i class="fa fa-question-circle"></i>
          </tooltip>
        </label>
      </div>
      <div class="col-md-3">
        <select
          :id="'oneFiftyDomShipment-' + index"
          v-model="address.carrierDetails.oneFiftyDomShipment"
          :name="'oneFiftyDomShipment-' + index"
          class="form-control"
          @blur="$v.carrierDetails.oneFiftyDomShipment.$touch()"
        >
          <option :value="{ id: '', name: '' }">Select Carrier & Service Level</option>
          <option
            v-for="list in oneFiftyDomCarrierList"
            :key="list.carrierId"
            :value="{ id: list.carrierId, name: list.carrierServiceNm }"
          >
            {{ list.carrierServiceNm }}
          </option>
        </select>
      </div>
      <div
        class="text-danger col-md-12"
        v-if="!$v.carrierDetails.oneFiftyDomShipment.required && $v.carrierDetails.oneFiftyDomShipment.$error"
      >
        Please select Domestic Carrier & Service Level for shipments 1-150 lbs
      </div>
    </div>
    <div v-if="isInternational && address.carrierDetails.transportInternationally == 'No'">
      <div class="col-md-12 form-group">
        <label class="control-label"
          >Freight forwarder:
          <tooltip
            :id="'freightForwarderOneFifty' + index"
            content="If your Freight Forwarder is not CEVA Logistics Cincinnati, you must provide a GE preffered carrier from the GE warehouse to the domestic address that you will list."
            class="product-helpinfo"
            effect="scale"
            placement="right"
            ><i class="fa fa-question-circle"></i>
          </tooltip>
        </label>
      </div>
      <div class="row col-md-12">
        <div class="col-md-3 form-group">
          <label :for="'freightForwarderOneFifty-name-' + index" class="control-label required">Name</label>
          <input
            :id="'freightForwarderOneFifty-name-' + index"
            v-model.trim="address.carrierDetails.freightForwarderOneFifty.name"
            :name="'freightForwarderOneFifty-name-' + index"
            type="text"
            class="form-control"
            @blur="$v.carrierDetails.freightForwarderOneFifty.name.$touch()"
          />
          <div
            v-if="
              !$v.carrierDetails.freightForwarderOneFifty.name.required &&
              $v.carrierDetails.freightForwarderOneFifty.name.$error
            "
            class="text-danger"
          >
            Please enter valid Name
          </div>
          <div
            v-if="
              !$v.carrierDetails.freightForwarderOneFifty.name.maxLength &&
              $v.carrierDetails.freightForwarderOneFifty.name.$error
            "
            class="text-danger"
          >
            Allowed upto 200 characters only
          </div>
        </div>
      </div>
      <div class="row col-md-12">
        <div class="col-md-3 form-group">
          <label :for="'freightForwarderOneFifty-line1-' + index" class="control-label required"
            >Carrier Address Line 1</label
          >
          <input
            :id="'freightForwarderOneFifty-line1-' + index"
            v-model.trim="address.carrierDetails.freightForwarderOneFifty.line1"
            :name="'freightForwarderOneFifty-line1-' + index"
            type="text"
            class="form-control"
            @blur="$v.carrierDetails.freightForwarderOneFifty.line1.$touch()"
          />
          <div
            class="text-danger"
            v-if="
              !$v.carrierDetails.freightForwarderOneFifty.line1.required &&
              $v.carrierDetails.freightForwarderOneFifty.line1.$error
            "
          >
            Please enter carrier address line 1
          </div>
          <div
            class="text-danger"
            v-if="
              !$v.carrierDetails.freightForwarderOneFifty.line1.maxLength &&
              $v.carrierDetails.freightForwarderOneFifty.line1.$error
            "
          >
            Allowed upto 500 characters only
          </div>
        </div>
        <div class="col-md-3 form-group">
          <label :for="'freightForwarderOneFifty-city-' + index" class="control-label required">City</label>
          <input
            :id="'freightForwarderOneFifty-city-' + index"
            v-model.trim="address.carrierDetails.freightForwarderOneFifty.city"
            :name="'freightForwarderOneFifty-city-' + index"
            type="text"
            class="form-control"
            @blur="$v.carrierDetails.freightForwarderOneFifty.city.$touch()"
          />
          <div
            class="text-danger"
            v-if="
              !$v.carrierDetails.freightForwarderOneFifty.city.required &&
              $v.carrierDetails.freightForwarderOneFifty.city.$error
            "
          >
            Please enter city
          </div>
          <div
            class="text-danger"
            v-if="
              !$v.carrierDetails.freightForwarderOneFifty.city.maxLength &&
              $v.carrierDetails.freightForwarderOneFifty.city.$error
            "
          >
            Allowed upto 100 characters only
          </div>
        </div>
      </div>
      <div class="row col-md-12">
        <div class="col-md-3 form-group">
          <label :for="'freightForwarderOneFifty-line2-' + index" class="control-label">Carrier Address Line 2</label>
          <input
            :id="'freightForwarderOneFifty-line2-' + index"
            v-model.trim="address.carrierDetails.freightForwarderOneFifty.line2"
            :name="'freightForwarderOneFifty-line2-' + index"
            type="text"
            class="form-control"
            @blur="$v.carrierDetails.freightForwarderOneFifty.line2.$touch()"
          />
          <div
            class="text-danger"
            v-if="
              !$v.carrierDetails.freightForwarderOneFifty.line2.maxLength &&
              $v.carrierDetails.freightForwarderOneFifty.line2.$error
            "
          >
            Allowed upto 500 characters only
          </div>
        </div>
        <div class="col-md-3 form-group">
          <label :for="'freightForwarderOneFifty-country-' + index" class="control-label required">Country</label>
          <select
            :id="'freightForwarderOneFifty-country-' + index"
            v-model="address.carrierDetails.freightForwarderOneFifty.country"
            :name="'freightForwarderOneFifty-country-' + index"
            class="form-control"
          >
            <option :value="{ id: USACountryId, name: USACountryName }">{{ USACountryName }}</option>
          </select>
        </div>
      </div>
      <div class="row col-md-12">
        <div class="col-md-3 form-group">
          <label :for="'freightForwarderOneFifty-line3-' + index" class="control-label">Carrier Address Line 3</label>
          <input
            :id="'freightForwarderOneFifty-line3-' + index"
            v-model.trim="address.carrierDetails.freightForwarderOneFifty.line3"
            :name="'freightForwarderOneFifty-line3-' + index"
            type="text"
            class="form-control"
            @blur="$v.carrierDetails.freightForwarderOneFifty.line3.$touch()"
          />
          <div
            class="text-danger"
            v-if="
              !$v.carrierDetails.freightForwarderOneFifty.line3.maxLength &&
              $v.carrierDetails.freightForwarderOneFifty.line3.$error
            "
          >
            Allowed upto 500 characters only
          </div>
        </div>
        <div class="col-md-3 form-group">
          <label :for="'freightForwarderOneFifty-state-' + index" class="control-label required"
            >State/Province/Region</label
          >
          <input
            :id="'freightForwarderOneFifty-state-' + index"
            v-model.trim="address.carrierDetails.freightForwarderOneFifty.state"
            :name="'freightForwarderOneFifty-state-' + index"
            type="text"
            class="form-control"
            @blur="$v.carrierDetails.freightForwarderOneFifty.state.$touch()"
          />
          <div
            class="text-danger"
            v-if="
              !$v.carrierDetails.freightForwarderOneFifty.state.required &&
              $v.carrierDetails.freightForwarderOneFifty.state.$error
            "
          >
            Please enter state/province/region
          </div>
          <div
            class="text-danger"
            v-if="
              !$v.carrierDetails.freightForwarderOneFifty.state.maxLength &&
              $v.carrierDetails.freightForwarderOneFifty.state.$error
            "
          >
            Allowed upto 100 characters only
          </div>
        </div>
      </div>
      <div class="row col-md-12">
        <div class="col-md-3 form-group">
          <label :for="'freightForwarderOneFifty-line4-' + index" class="control-label">Carrier Address Line 4</label>
          <input
            :id="'freightForwarderOneFifty-line4-' + index"
            v-model.trim="address.carrierDetails.freightForwarderOneFifty.line4"
            :name="'freightForwarderOneFifty-line4-' + index"
            type="text"
            class="form-control"
            @blur="$v.carrierDetails.freightForwarderOneFifty.line4.$touch()"
          />
          <div
            class="text-danger"
            v-if="
              !$v.carrierDetails.freightForwarderOneFifty.line4.maxLength &&
              $v.carrierDetails.freightForwarderOneFifty.line4.$error
            "
          >
            Allowed upto 500 characters only
          </div>
        </div>
        <div class="col-md-3 form-group">
          <label :for="'freightForwarderOneFifty-ZipCode-' + index" class="control-label required"
            >Zip/Postal Code</label
          >
          <input
            :id="'freightForwarderOneFifty-ZipCode-' + index"
            v-model.trim="address.carrierDetails.freightForwarderOneFifty.zipCode"
            :name="'freightForwarderOneFifty-ZipCode-' + index"
            type="text"
            class="form-control"
            @blur="$v.carrierDetails.freightForwarderOneFifty.zipCode.$touch()"
          />
          <div
            class="text-danger"
            v-if="
              !$v.carrierDetails.freightForwarderOneFifty.zipCode.required &&
              $v.carrierDetails.freightForwarderOneFifty.zipCode.$error
            "
          >
            Please enter zip/postal code
          </div>
          <div
            class="text-danger"
            v-if="
              !$v.carrierDetails.freightForwarderOneFifty.zipCode.maxLength &&
              $v.carrierDetails.freightForwarderOneFifty.zipCode.$error
            "
          >
            Allowed upto 20 characters only
          </div>
        </div>
      </div>
    </div>
    <div class="form-group col-md-12" v-if="isInternational">
      <label class="control-label required"> Will you use same shipping details for shipments 151-1000 lbs? </label>
      <div class="ship-radio-btns">
        <label class="radio-inline">
          <input
            :id="'shipmentAddressSameYes' + index"
            v-model="address.carrierDetails.shipmentAddressSame"
            type="radio"
            value="Yes"
            @blur="$v.carrierDetails.shipmentAddressSame.$touch"
            @change="shipmentAddressSameChanged"
          />
          <span>Yes</span>
        </label>
        <label class="radio-inline">
          <input
            :id="'shipmentAddressSameNo' + index"
            v-model="address.carrierDetails.shipmentAddressSame"
            type="radio"
            value="No"
            @blur="$v.carrierDetails.shipmentAddressSame.$touch"
            @change="shipmentAddressSameChanged"
          />
          <span>No</span>
        </label>
      </div>
      <div
        v-if="!$v.carrierDetails.shipmentAddressSame.required && $v.carrierDetails.shipmentAddressSame.$error"
        class="text-danger"
      >
        Please select will you use same shipping details for shipments 151-1000 lbs
      </div>
    </div>
    <div
      class="form-group col-md-12 row"
      v-if="isDomestic || (isInternational && address.carrierDetails.shipmentAddressSame == 'No')"
    >
      <div class="col-md-12">
        <label class="control-label required" :for="'thousandDomShipment-' + index"
          >Domestic Carrier & Service Level for shipments 151-1000 lbs:
          <tooltip
            :id="'thousand-dom-shipment' + index"
            :content="shipmentTooltipMsg"
            class="product-helpinfo"
            effect="scale"
            placement="right"
            ><i class="fa fa-question-circle"></i>
          </tooltip>
        </label>
      </div>
      <div class="col-md-3">        
        <select
          :id="'thousandDomShipment-' + index"
          v-model="address.carrierDetails.thousandDomShipment"
          :name="'thousandDomShipment-' + index"
          class="form-control"
          @blur="$v.carrierDetails.thousandDomShipment.$touch()"
        >
          <option :value="{ id: '', name: '' }">Select Carrier & Service Level</option>
          <option
            v-for="list in thousandDomCarrierList"
            :key="list.carrierId"
            :value="{ id: list.carrierId, name: list.carrierServiceNm }"
          >
            {{ list.carrierServiceNm }}
          </option>
        </select>
      </div>
      <div
        class="text-danger col-md-12"
        v-if="!$v.carrierDetails.thousandDomShipment.required && $v.carrierDetails.thousandDomShipment.$error"
      >
        Please select Domestic Carrier & Service Level for shipments 151-1000 lbs
      </div>
    </div>
    <div v-if="isInternational && address.carrierDetails.shipmentAddressSame == 'No'">
      <div class="col-md-12 form-group">
        <label class="control-label"
          >Freight forwarder:
          <tooltip
            :id="'freightForwarderOneThousand' + index"
            content="If your Freight Forwarder is not CEVA Logistics Cincinnati, you must provide a GE preffered carrier from the GE warehouse to the domestic address that you will list."
            class="product-helpinfo"
            effect="scale"
            placement="right"
            ><i class="fa fa-question-circle"></i>
          </tooltip>
        </label>
      </div>
      <div class="row col-md-12">
        <div class="col-md-3 form-group">
          <label :for="'freightForwarderOneThousand-name-' + index" class="control-label required">Name</label>
          <input
            :id="'freightForwarderOneThousand-name-' + index"
            v-model.trim="address.carrierDetails.freightForwarderOneThousand.name"
            :name="'freightForwarderOneThousand-name-' + index"
            type="text"
            class="form-control"
            @blur="$v.carrierDetails.freightForwarderOneThousand.name.$touch()"
          />
          <div
            v-if="
              !$v.carrierDetails.freightForwarderOneThousand.name.required &&
              $v.carrierDetails.freightForwarderOneThousand.name.$error
            "
            class="text-danger"
          >
            Please enter valid Name
          </div>
          <div
            v-if="
              !$v.carrierDetails.freightForwarderOneThousand.name.maxLength &&
              $v.carrierDetails.freightForwarderOneThousand.name.$error
            "
            class="text-danger"
          >
            Allowed upto 200 characters only
          </div>
        </div>
      </div>
      <div class="row col-md-12">
        <div class="col-md-3 form-group">
          <label :for="'freightForwarderOneThousand-line1-' + index" class="control-label required"
            >Carrier Address Line 1</label
          >
          <input
            :id="'freightForwarderOneThousand-line1-' + index"
            v-model.trim="address.carrierDetails.freightForwarderOneThousand.line1"
            :name="'freightForwarderOneThousand-line1-' + index"
            type="text"
            class="form-control"
            @blur="$v.carrierDetails.freightForwarderOneThousand.line1.$touch()"
          />
          <div
            class="text-danger"
            v-if="
              !$v.carrierDetails.freightForwarderOneThousand.line1.required &&
              $v.carrierDetails.freightForwarderOneThousand.line1.$error
            "
          >
            Please enter carrier address line 1
          </div>
          <div
            class="text-danger"
            v-if="
              !$v.carrierDetails.freightForwarderOneThousand.line1.maxLength &&
              $v.carrierDetails.freightForwarderOneThousand.line1.$error
            "
          >
            Allowed upto 500 characters only
          </div>
        </div>
        <div class="col-md-3 form-group">
          <label :for="'freightForwarderOneThousand-city-' + index" class="control-label required">City</label>
          <input
            :id="'freightForwarderOneThousand-city-' + index"
            v-model.trim="address.carrierDetails.freightForwarderOneThousand.city"
            :name="'freightForwarderOneThousand-city-' + index"
            type="text"
            class="form-control"
            @blur="$v.carrierDetails.freightForwarderOneThousand.city.$touch()"
          />
          <div
            class="text-danger"
            v-if="
              !$v.carrierDetails.freightForwarderOneThousand.city.required &&
              $v.carrierDetails.freightForwarderOneThousand.city.$error
            "
          >
            Please enter city
          </div>
          <div
            class="text-danger"
            v-if="
              !$v.carrierDetails.freightForwarderOneThousand.city.maxLength &&
              $v.carrierDetails.freightForwarderOneThousand.city.$error
            "
          >
            Allowed upto 100 characters only
          </div>
        </div>
      </div>
      <div class="row col-md-12">
        <div class="col-md-3 form-group">
          <label :for="'freightForwarderOneThousand-line2-' + index" class="control-label">Carrier Address Line 2</label>
          <input
            :id="'freightForwarderOneThousand-line2-' + index"
            v-model.trim="address.carrierDetails.freightForwarderOneThousand.line2"
            :name="'freightForwarderOneThousand-line2-' + index"
            type="text"
            class="form-control"
            @blur="$v.carrierDetails.freightForwarderOneThousand.line2.$touch()"
          />
          <div
            class="text-danger"
            v-if="
              !$v.carrierDetails.freightForwarderOneThousand.line2.maxLength &&
              $v.carrierDetails.freightForwarderOneThousand.line2.$error
            "
          >
            Allowed upto 500 characters only
          </div>
        </div>
        <div class="col-md-3 form-group">
          <label :for="'freightForwarderOneThousand-country-' + index" class="control-label required">Country</label>
          <select
            :id="'freightForwarderOneThousand-country-' + index"
            v-model="address.carrierDetails.freightForwarderOneThousand.country"
            :name="'freightForwarderOneThousand-country-' + index"
            class="form-control"
          >
            <option :value="{ id: USACountryId, name: USACountryName }">{{ USACountryName }}</option>
          </select>
        </div>
      </div>
      <div class="row col-md-12">
        <div class="col-md-3 form-group">
          <label :for="'freightForwarderOneThousand-line3-' + index" class="control-label">Carrier Address Line 3</label>
          <input
            :id="'freightForwarderOneThousand-line3-' + index"
            v-model.trim="address.carrierDetails.freightForwarderOneThousand.line3"
            :name="'freightForwarderOneThousand-line3-' + index"
            type="text"
            class="form-control"
            @blur="$v.carrierDetails.freightForwarderOneThousand.line3.$touch()"
          />
          <div
            class="text-danger"
            v-if="
              !$v.carrierDetails.freightForwarderOneThousand.line3.maxLength &&
              $v.carrierDetails.freightForwarderOneThousand.line3.$error
            "
          >
            Allowed upto 500 characters only
          </div>
        </div>
        <div class="col-md-3 form-group">
          <label :for="'freightForwarderOneThousand-state-' + index" class="control-label required"
            >State/Province/Region</label
          >
          <input
            :id="'freightForwarderOneThousand-state-' + index"
            v-model.trim="address.carrierDetails.freightForwarderOneThousand.state"
            :name="'freightForwarderOneThousand-state-' + index"
            type="text"
            class="form-control"
            @blur="$v.carrierDetails.freightForwarderOneThousand.state.$touch()"
          />
          <div
            class="text-danger"
            v-if="
              !$v.carrierDetails.freightForwarderOneThousand.state.required &&
              $v.carrierDetails.freightForwarderOneThousand.state.$error
            "
          >
            Please enter state/province/region
          </div>
          <div
            class="text-danger"
            v-if="
              !$v.carrierDetails.freightForwarderOneThousand.state.maxLength &&
              $v.carrierDetails.freightForwarderOneThousand.state.$error
            "
          >
            Allowed upto 100 characters only
          </div>
        </div>
      </div>
      <div class="row col-md-12">
        <div class="col-md-3 form-group">
          <label :for="'freightForwarderOneThousand-line4-' + index" class="control-label">Carrier Address Line 4</label>
          <input
            :id="'freightForwarderOneThousand-line4-' + index"
            v-model.trim="address.carrierDetails.freightForwarderOneThousand.line4"
            :name="'freightForwarderOneThousand-line4-' + index"
            type="text"
            class="form-control"
            @blur="$v.carrierDetails.freightForwarderOneThousand.line4.$touch()"
          />
          <div
            class="text-danger"
            v-if="
              !$v.carrierDetails.freightForwarderOneThousand.line4.maxLength &&
              $v.carrierDetails.freightForwarderOneThousand.line4.$error
            "
          >
            Allowed upto 500 characters only
          </div>
        </div>
        <div class="col-md-3 form-group">
          <label :for="'freightForwarderOneThousand-ZipCode-' + index" class="control-label required"
            >Zip/Postal Code</label
          >
          <input
            :id="'freightForwarderOneThousand-ZipCode-' + index"
            v-model.trim="address.carrierDetails.freightForwarderOneThousand.zipCode"
            :name="'freightForwarderOneThousand-ZipCode-' + index"
            type="text"
            class="form-control"
            @blur="$v.carrierDetails.freightForwarderOneThousand.zipCode.$touch()"
          />
          <div
            class="text-danger"
            v-if="
              !$v.carrierDetails.freightForwarderOneThousand.zipCode.required &&
              $v.carrierDetails.freightForwarderOneThousand.zipCode.$error
            "
          >
            Please enter zip/postal code
          </div>
          <div
            class="text-danger"
            v-if="
              !$v.carrierDetails.freightForwarderOneThousand.zipCode.maxLength &&
              $v.carrierDetails.freightForwarderOneThousand.zipCode.$error
            "
          >
            Allowed upto 20 characters only
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import tooltip from "build-ui-x/src/Tooltip";
import { requiredIf, maxLength } from "vuelidate/lib/validators";
import { FreightForwarder, KeyValuePair } from "@/model/CarrierDetails";

export default {
  components: {
    tooltip,
  },
  props: {
    address: {
      type: Object,
      default: () => ({}),
    },
    index: {
      type: Number,
    },
  },
  data() {
    return {
      USACountryName: "UNITED STATES",
      USACountryId: 232,
    };
  },
  created() {
    this.$v.carrierDetails.$touch();
    this.$emit("carrierDetailsStatus", { status: this.$v.carrierDetails.$invalid, index: this.index });
  },
  watch: {
    "address.carrierDetails": {
      handler: function () {
        this.$emit("carrierDetailsStatus", { status: this.$v.carrierDetails.$invalid, index: this.index });
      },
      deep: true,
    },
    "address.country": {
      handler: function () {
        this.$v.carrierDetails.$reset();
        this.$emit("carrierDetailsStatus", { status: this.$v.carrierDetails.$invalid, index: this.index });
      },
    },
  },
  computed: {
    carrierDetails() {
      return this.address.carrierDetails;
    },
    isDomestic() {
      return this.address.country == 232 || this.address.country == 233;
    },
    isInternational() {
      return this.address.country != 232 && this.address.country != 233 && this.address.country != "";
    },
    oneFiftyDomCarrierList() {
      return this.$store.getters["carrierList/oneFiftyDomCarrierList"]
    },
    thousandDomCarrierList() {
      return this.$store.getters["carrierList/thousandDomCarrierList"]
    },
    oneFiftyIntCarrierList() {
      return this.$store.getters["carrierList/oneFiftyIntCarrierList"]
    },
    shipmentTooltipMsg() {
      if (this.isDomestic)
        return "These carriers pick up on a daily business-day basis from GE, providing instant tracking/AWB numbers, and deliver to your U.S. based customer location.";
      if (this.isInternational)
        return "These carriers pick up on a daily business-day basis from GE, providing instant tracking/AWB numbers, and deliver to your U.S. based Freight Forwarder.";
    },
  },
  methods: {
    transportInternationallyChanged() {
      this.address.carrierDetails.oneFiftyDomShipment = new KeyValuePair();
      this.address.carrierDetails.oneFiftyIntShipment = new KeyValuePair();
      this.address.carrierDetails.freightForwarderOneFifty = new FreightForwarder();
    },
    shipmentAddressSameChanged() {
      this.address.carrierDetails.thousandDomShipment = new KeyValuePair();
      this.address.carrierDetails.freightForwarderOneThousand = new FreightForwarder();
    },
  },
  validations: {
    carrierDetails: {
      oneFiftyDomShipment: {
        id: {
          required: requiredIf(function () {
            return (
              this.isDomestic || (this.isInternational && this.address.carrierDetails.transportInternationally == 'No')
            );
          }),
        },
      },
      thousandDomShipment: {
        id: {
          required: requiredIf(function () {
            return (
              this.isDomestic || (this.isInternational && this.address.carrierDetails.shipmentAddressSame == 'No')
            );
          }),
        },
      },
      oneFiftyIntShipment: {
        id: {
          required: requiredIf(function () {
            return this.isInternational && this.address.carrierDetails.transportInternationally == 'Yes';
          }),
        },
      },
      transportInternationally: {
        required: requiredIf(function () {
          return this.isInternational;
        }),
      },
      shipmentAddressSame: {
        required: requiredIf(function () {
          return this.isInternational;
        }),
      },
      freightForwarderOneFifty: {
        name: {
          maxLength: maxLength(200),
          required: requiredIf(function () {
            return this.isInternational && this.address.carrierDetails.transportInternationally == 'No';
          }),
        },
        line1: {
          maxLength: maxLength(500),
          required: requiredIf(function () {
            return this.isInternational && this.address.carrierDetails.transportInternationally == 'No';
          }),
        },
        line2: {
          maxLength: maxLength(500),
        },
        line3: {
          maxLength: maxLength(500),
        },
        line4: {
          maxLength: maxLength(500),
        },
        city: {
          maxLength: maxLength(100),
          required: requiredIf(function () {
            return this.isInternational && this.address.carrierDetails.transportInternationally == 'No';
          }),
        },
        state: {
          maxLength: maxLength(100),
          required: requiredIf(function () {
            return this.isInternational && this.address.carrierDetails.transportInternationally == 'No';
          }),
        },
        zipCode: {
          maxLength: maxLength(20),
          required: requiredIf(function () {
            return this.isInternational && this.address.carrierDetails.transportInternationally == 'No';
          }),
        },
      },
      freightForwarderOneThousand: {
        name: {
          maxLength: maxLength(200),
          required: requiredIf(function () {
            return this.isInternational && this.address.carrierDetails.shipmentAddressSame == 'No';
          }),
        },
        line1: {
          maxLength: maxLength(500),
          required: requiredIf(function () {
            return this.isInternational && this.address.carrierDetails.shipmentAddressSame == 'No';
          }),
        },
        line2: {
          maxLength: maxLength(500),
        },
        line3: {
          maxLength: maxLength(500),
        },
        line4: {
          maxLength: maxLength(500),
        },
        city: {
          maxLength: maxLength(100),
          required: requiredIf(function () {
            return this.isInternational && this.address.carrierDetails.shipmentAddressSame == 'No';
          }),
        },
        state: {
          maxLength: maxLength(100),
          required: requiredIf(function () {
            return this.isInternational && this.address.carrierDetails.shipmentAddressSame == 'No';
          }),
        },
        zipCode: {
          maxLength: maxLength(20),
          required: requiredIf(function () {
            return this.isInternational && this.address.carrierDetails.shipmentAddressSame == 'No';
          }),
        },
      },
    },
  },
};
</script>
<style lang="less" scoped>
.ship-radio-btns {
  padding-left: 10px;
  .radio-inline {
    margin-right: 15px;
    input[type="radio"] {
      cursor: pointer;
    }
    span {
      vertical-align: middle;
    }
  }
}
</style>
